import React, { Fragment } from "react";
import styled from "react-emotion";

import theme from "components/theme";

import FooterCategoryHeader from "./FooterCategoryHeader";

const HeaderLine = styled("div")`
  margin: 5px auto 15px;
  width: 50px;
  height: 2px;
  border: solid 2px ${theme.colors.primary};
`;

const HeaderWrapper = styled("div")`
  text-align: center;
`;

function HeaderWithTopLine(props) {
  const { title = "", size = "18px" } = props;
  return (
    <Fragment>
      <HeaderLine />
      <HeaderWrapper>
        <FooterCategoryHeader categoryName={title} size={size} />
      </HeaderWrapper>
    </Fragment>
  );
}

export default HeaderWithTopLine;
